import { jsxs as k, Fragment as p, jsx as a } from "react/jsx-runtime";
import { useState as g, useCallback as e } from "react";
import x from "../Button/index.js";
import b from "../ConfirmModal/index.js";
function S(s) {
  const {
    confirmHeading: m,
    confirmMessage: f,
    name: i,
    onConfirm: r,
    onClick: n,
    ...l
  } = s, [c, o] = g(!1), C = e(
    (t) => {
      o(!1), r(t);
    },
    [r]
  ), u = e(
    () => {
      o(!1);
    },
    []
  ), d = e(
    (t, h) => {
      n && n(t, h), o(!0);
    },
    [n]
  );
  return /* @__PURE__ */ k(p, { children: [
    /* @__PURE__ */ a(
      x,
      {
        ...l,
        name: i,
        onClick: d
      }
    ),
    c && /* @__PURE__ */ a(
      b,
      {
        name: i,
        heading: m,
        message: f,
        onCancel: u,
        onConfirm: C
      }
    )
  ] });
}
export {
  S as default
};
